import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { collegeList2Columns } from '../../Data/CollegeManagement/collegeList2Columns'
import { getAllData, deleteIdData } from '../../lib/collegeList2'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const COLLEGE_LIST2_TABLE_STYLES = {
	headRow: {
		style: {
			alignItems: 'stretch',
			minHeight: 'unset'
		}
	},
	headCells: {
		style: {
			fontSize: '11px',
			whiteSpace: 'normal',
			overflow: 'visible',
			textOverflow: 'clip',
			wordBreak: 'break-word',
			lineHeight: 1.25,
			minHeight: '48px',
			paddingTop: '10px',
			paddingBottom: '10px',
			alignItems: 'center',
			justifyContent: 'center'
		}
	}
}

const SEARCH_FIELDS = [
	'class',
	'college_name',
	'state',
	'city',
	'ranking',
	'gpa',
	'acceptance',
	'0_10',
	'1_11',
	'26_50',
	'51_75',
	'76_100',
	'low_sat',
	'high_sat',
	'low_act',
	'high_act',
	'tuition',
	'undergraduate_enrollment'
]

const AdminCollegeList2 = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: rows, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	const sortedRows = React.useMemo(() => {
		return [...rows].sort((a, b) => {
			const nameA = a.college_name ? String(a.college_name) : ''
			const nameB = b.college_name ? String(b.college_name) : ''
			return nameA.localeCompare(nameB)
		})
	}, [rows])

	return (
		<DataManagementGrid
			title="Desired Colleges 2"
			subTitle="Manage college list 2 reference data (listcollege)"
			breadcrumbTitle="College Management"
			breadcrumbMainTitle="College Management"
			customTableStyles={COLLEGE_LIST2_TABLE_STYLES}
			columns={(l, r) => collegeList2Columns(l, r)}
			data={sortedRows}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by college, class, state, city, or numbers…"
			createButtonText="Add college"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/college-list-2/create/${layout}`}
			onDelete={handleDelete}
			searchFields={SEARCH_FIELDS}
			noDataMessage="No colleges in list"
		/>
	)
}

export { AdminCollegeList2 }
